import ScrollBackMixins from "./scrollBack";
export default {
  mixins: [ScrollBackMixins],
  beforeRouteEnter(to, from, next) {
    next((vm) =>
      vm.routeScrollBack(
        from.name,
        ["customer-detail-1", "policyRelation"],
        window.$("main")
      )
    );
  },
  beforeRouteLeave(to, from, next) {
    this.routeScrollSave(
      to.name,
      ["customer-detail-1", "policyRelation"],
      window.$("main")
    );
    next();
  }
};
